import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import cx from 'classnames'
import { Helmet } from 'react-helmet-async'

const CREATOR_MAX_WIDTH = 428
const ADMIN_MAX_WIDTH = 1600

export const LAYOUT_PADDING_VERTICAL = 24
export const getMaxWidth = (mode: Mode) =>
  `calc(min(${
    mode === 'creator' ? CREATOR_MAX_WIDTH : ADMIN_MAX_WIDTH
  }px, 100%))`

export type Mode = 'creator' | 'admin'

interface StyleProps {
  mode: Mode
}

const useStyles = createUseStyles({
  body: {
    backgroundColor: '#F9F6F4',
  },
  root: {
    minHeight: '100dvh',
    overflowX: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: LAYOUT_PADDING_VERTICAL,
    paddingBottom: LAYOUT_PADDING_VERTICAL,
  },
  container: {
    width: '100%',
    maxWidth: ({ mode }: StyleProps) => getMaxWidth(mode),
    position: 'relative',
  },
})

interface Props {
  mode: Mode
  className?: string
  containerClassName?: string
}

export const Layout: FC<Props> = flowMax(
  addDisplayName('Layout'),
  addProps(({ mode }) => ({
    classes: useStyles({ mode }),
  })),
  ({ children, classes, className, containerClassName }) => (
    <>
      <div className={cx(classes.root, className)}>
        <div className={cx(classes.container, containerClassName)}>
          {children}
        </div>
      </div>
      <Helmet>
        <body className={classes.body} />
      </Helmet>
    </>
  )
)
